import * as React from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import {
  Button,
  Card,
  Container,
  Divider,
  Dropdown,
  DropdownItemProps,
  Form,
  Icon,
  Input,
  Message,
  Segment
} from 'semantic-ui-react'
import MarqueeBanner from '../RollItemStore/containers/MarqueeBanner'
import { tipService } from '../../../../services'
import { calculateTipVnd } from '../../../../utils/common'
import TipRequestResult from './TipRequestResult'
import _ = require('lodash')

type TipStoreProps = {
  isLoggedIn: boolean,
  user: IUser,
}

type TipStoreState = {
  isLoading: boolean,
  tipHomeInfo: TipHomeInfo,
  steamId: string,
  bank: string,
  amount: number,
  amountVnd: number,
  errorFields: any,
  isRequestSuccess: boolean,
  tipId: number,
  depId: number,
}

class TipStore extends React.Component<TipStoreProps> {
  state: TipStoreState = {
    isLoading: true,
    steamId: '',
    bank: 'VCB',
    amount: 0,
    amountVnd: 0,
    tipHomeInfo: {
      csgoEmpireRate: 0,
      balance: 0,
      banks: [],
      buyingRate: 0,
      cardInfoList: [],
      webIntro: '',
      webIntroForCard: ''
    },
    errorFields: {},
    isRequestSuccess: false,
    tipId: 0,
    depId: 0,
  }

  async componentDidMount() {
    await this.getTipHomeInfo()
  }

  getTipHomeInfo = async () => {
    try {
      this.setState({
        isLoading: true,
        isRequestSuccess: false
      })
      const response = await tipService.getTipHomeInfo()
      this.setState({
        tipHomeInfo: response
      })
    } catch (error) {
      toast.error(error.message)
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  getBankDropdownOptions = () => {
    return _.chain(this.state.tipHomeInfo.banks)
      .sortBy(['priority'])
      .map(function (bankInfo: TipBankInfo): DropdownItemProps {
        return {
          value: bankInfo.code,
          text: bankInfo.name
        }
      }).value()
  }

  handleChangeFormField = (_event: any, data: { name: string, value: string }) => {
    let amountVnd = this.state.amountVnd
    if (data.name === 'amount') {
      amountVnd = calculateTipVnd(parseFloat(data.value), this.state.tipHomeInfo.csgoEmpireRate)
    }
    this.setState({
      [data.name]: data.value,
      amountVnd: amountVnd
    })
  }

  handleSubmitForm = async () => {
    const {steamId, amount, bank, tipHomeInfo} = this.state

    this.setState({
      isLoading: true,
      isRequestSuccess: false,
      errorFields: {}
    })

    let errorFields: any = {}
    if (!steamId || steamId.length !== 17) {
      errorFields.steamId = 'SteamID không hợp lệ!'
    }

    if (!amount || isNaN(amount) || amount < 0.1 || amount > tipHomeInfo.balance) {
      errorFields.amount = `Số lượng coin không hợp lệ! (từ 0.1 đến ${tipHomeInfo.balance})`
    }
    if (!bank) {
      errorFields.bank = 'Phương thức thanh toán không hợp lệ!'
    }
    if (!_.isEmpty(errorFields)) {
      this.setState({
        errorFields: errorFields,
        isLoading: false
      })
      return
    }

    try {
      let requestTipResult = await tipService.requestTip({
        steamId: steamId,
        amount: amount,
        bank: bank
      })
      this.setState({
        isRequestSuccess: true,
        tipId: requestTipResult.tipId,
        depId: requestTipResult.depId,
      })
    } catch (e) {
      toast.error(e.message)
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  render() {
    const state = this.state

    return (
      <div>
        <MarqueeBanner/>
        <Divider horizontal={true}/>
        <Container className="container store">
          <Card style={{border: 'none', margin: '20px'}} fluid={true}>
            <Card.Content>
              <Card.Header>Mua coin CSGOEmpire (có sẵn: ${state.tipHomeInfo.balance.toLocaleString('vn')})</Card.Header>
            </Card.Content>
            <Card.Content style={{minHeight: '600px'}}>
              <Segment loading={state.isLoading}>
            {state.isRequestSuccess
              && <TipRequestResult isSuccess={state.isRequestSuccess} tipId={state.tipId} depId={state.depId}/>
            }
            {!_.isEmpty(state.errorFields) && <Message
                error={true}
                header={'Lỗi'}
                list={_.values(state.errorFields)}
            />}
            <Divider horizontal={true} inverted={true}/>
              <div style={{margin: 'auto', width: '80%'}}>
            <Form onSubmit={this.handleSubmitForm}>
              <Form.Field
                name={'steamId'}
                required={true}
                control={Input}
                label={'Steam ID (id64)'}
                value={state.steamId}
                error={state.errorFields.steamId}
                onChange={this.handleChangeFormField}
              />
              <Form.Group inline={true}>
                <Form.Field
                  required={true}
                  label={'Số lượng coin'}
                  name={'amount'}
                  control={Input}
                  value={state.amount}
                  onChange={this.handleChangeFormField}
                  error={state.errorFields.amount}
                />
                <Icon name={'exchange'} style={{paddingRight: '2em'}}/>
                <Form.Field readOnly={true}>
                  <Input
                    type={'number'}
                    value={state.amountVnd}
                    error={state.errorFields.amount}
                    label={'VND'}
                    labelPosition={'right'}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Field required={true} error={state.errorFields.bank}>
                <label>Phương thức thanh toán</label>
                <Dropdown
                  selection={true}
                  value={state.bank}
                  name={'bank'}
                  options={this.getBankDropdownOptions()}
                  onChange={this.handleChangeFormField}
                />
              </Form.Field>
              <Button color={'blue'}>Mua</Button>
            </Form>
              </div>
              </Segment>
            </Card.Content>
          </Card>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  isLoggedIn: state.loggedIn,
  user: state.root.userInfo,
})

export default connect(mapStateToProps)(TipStore)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Tip/TipStore.tsx